import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAbPrgaa-p2kmL9goPK6Jy99y8pKZzRh2w",
  authDomain: "palmarama-reservas.firebaseapp.com",
  projectId: "palmarama-reservas",
  storageBucket: "palmarama-reservas.firebasestorage.app",
  messagingSenderId: "622039861092",
  appId: "1:622039861092:web:a8c141c7fb9ef803f35c71"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  // En celulares algunas conexiones WebChannel de Firestore se quedan esperando ~30s
  // después de usar la cámara/QR. Forzar long polling evita ese timeout y hace
  // más estable el escaneo consecutivo desde portería.
  experimentalForceLongPolling: true,
  useFetchStreams: false,
});
